import { Button } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useState } from "react";
import { db } from "../../../firebase";

function DigitalCard({
  item,
  removeHandler,
  i,
  digitalDashboard,
  reloadState,
}) {
  const [, setReload] = reloadState;
  const [loadin, setLoadin] = useState(false);
  const [priority, setPriority] = useState(item.priority);
  const [change, setChange] = useState(false);

  const priorityHandler = async () => {
    digitalDashboard[i] = {
      ...digitalDashboard[i],
      priority: Number(priority),
    };
    setLoadin(true);

    // console.log(digitalDashboard);

    try {
      await db.collection("HomePageData").doc("ScreenData").update({
        digitalBoard: digitalDashboard,
      });
      setReload((p) => !p);
    } catch (e) {
      console.log(e);
    }
    setLoadin(false);
  };

  //   console.log(item.priority, priority);
  //   console.log(digitalDashboard);
  //   console.log(i);
  return (
    <div className="homepage__slide">
      <p className="homepage__slide__title">
        {item.type === 0 ? "Text" : "Image"}
      </p>
      <div className="homepage__slide__close">
        <Close onClick={() => removeHandler(i, item)} />
      </div>
      <div className="homepage__slide__priority">
        <input
          value={priority}
          type="number"
          onChange={(e) => {
            setPriority(e.target.value);
            setChange(true);
          }}
        />
        <Button
          variant="contained"
          color="primary"
          style={{
            fontSize: "11px",
            padding: "1px",
            visibility: !change ? "hidden" : "visible",
          }}
          onClick={priorityHandler}
          disabled={loadin}
        >
          Done
        </Button>
        <Close
          style={{
            color: "black",
            cursor: "pointer",
            visibility: !change ? "hidden" : "visible",
          }}
          onClick={() => {
            setChange(false);
            setPriority(item.priority);
          }}
        />
      </div>
      {item.type === 0 ? (
        <>
          <p className="homepage__slide__info">{item.info}</p>
        </>
      ) : (
        <img
          src={item.info}
          alt=""
          onClick={() => window.open(item.info, "_blank")}
        />
      )}
    </div>
  );
}

export default DigitalCard;
